<template>
  <div>
    <div class="content">
      <div class="row align-items-center">
        <div class="col-md-6"></div>
        <div class="col-md-6 text-left text-md-right mt-3 mt-md-0">
          <Botao
            title="Nova Locação"
            :link="linkCadastro"
            nameClass="btn btn-warning font-weight-bold px-4"
            >CLIQUE AQUI PARA CADASTRAR UM {{ descMenu }}</Botao
          >
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="loading">
      <loading />
    </div>
    <div class="row" v-else>
      <div class="col-md-3">
        <div
          class="nav flex-column nav-pills nav-perfil"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <a
            class="nav-link"
            role="tab"
            @click="alterarMenu(1)"
            href="#"
            :class="
              menu === 1
                ? 'router-link-exact-active active router-link-active'
                : ''
            "
          >
            <span class="d-md-flex">Anúncios</span>
            <i class="material-icons">flag</i>
          </a>
          <a
            class="nav-link"
            role="tab"
            @click="alterarMenu(3)"
            href="#"
            :class="
              menu === 3
                ? 'router-link-exact-active active router-link-active'
                : ''
            "
          >
            <span class="d-md-flex">Banner</span>
            <i class="material-icons">image</i>
          </a>
          <a
            class="nav-link"
            role="tab"
            @click="alterarMenu(2)"
            href="#"
            :class="
              menu === 2
                ? 'router-link-exact-active active router-link-active'
                : ''
            "
          >
            <span class="d-md-flex">Usuários</span>
            <i class="material-icons">school</i>
          </a>
          <a class="nav-link danger" role="tab" @click="cancelar()" href="#">
            <span class="d-md-flex">Cancelar Clube</span>
            <i class="material-icons">cancel</i>
          </a>
        </div>
      </div>
      <div class="col-md-9">
        <transition mode="out-in">
          <div v-if="menu == 1">
            <Titulo
              title="Anúncios"
              description="Lista dos Anúncios cadastrados"
            />
            <div class="row justify-content-center" v-if="loading">
              <loading />
            </div>
            <div v-else-if="listaAnuncio.length > 0">
              <ListaAnuncios
                class="mt-5"
                :lista="listaAnuncio"
                @click="retorno"
              />
              <div>
                <b-pagination
                  v-if="this.listaAnuncio.length"
                  v-model="pagina"
                  :total-rows="qtdRegistrosAnuncio"
                  :per-page="porPagina"
                  @change="selecionaPaginaAnuncio"
                  align="center"
                ></b-pagination>
              </div>
            </div>
            <div class="col-12" v-else>
              <div
                class="border-0 py-5 d-flex justify-content-center align-items-center"
              >
                <h5>Nenhum anúncio encontrado. 😟</h5>
              </div>
            </div>
          </div>
          <div v-else-if="menu == 2">
            <Titulo
              title="Usuários"
              description="Lista de Usuários cadastrados"
            />
            <div class="row justify-content-center" v-if="loading">
              <loading />
            </div>
            <div v-else-if="lista.length > 0">
              <div class="row align-items-center">
                <div class="col-md-6 mt-3 mt-md-0">
                  <Botao
                    title="Nova Locação"
                    link="/produto/clube-vantagens/remover-usuarios"
                    nameClass="btn btn-danger font-weight-bold px-4"
                    >REMOVER USUÁRIOS EM MASSA</Botao
                  >
                </div>
              </div>
              <ListaUsuarios class="mt-5" :lista="lista" @click="retorno" />
              <div>
                <b-pagination
                  v-if="this.lista.length"
                  v-model="pagina"
                  :total-rows="qtdRegistros"
                  :per-page="porPagina"
                  @change="selecionaPagina"
                  align="center"
                ></b-pagination>
              </div>
            </div>
            <div class="col-12" v-else>
              <div
                class="border-0 py-5 d-flex justify-content-center align-items-center"
              >
                <h5>Nenhum usuário encontrado. 😟</h5>
              </div>
            </div>
          </div>
          <div v-else-if="menu == 3">
            <Titulo title="Banner" description="Lista de Banner Cadastrado" />
            <div class="row justify-content-center" v-if="loading">
              <loading />
            </div>
            <div v-else-if="listaBanner.length > 0">
              <ListaBanners
                class="mt-5"
                :lista="listaBanner"
                @click="retorno"
              />
            </div>
            <div class="col-12" v-else>
              <div
                class="border-0 py-5 d-flex justify-content-center align-items-center"
              >
                <h5>Nenhum banner encontrado. 😟</h5>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="py-5"></div>
  </div>
</template>
<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import ListaUsuarios from "@/components/cadastro/ListaUsuarios";
import ListaAnuncios from "@/components/cadastro/ListaAnuncios";
import ListaBanners from "@/components/cadastro/ListaBanners";

export default {
  name: "Lista",
  components: { Titulo, Botao, ListaUsuarios, ListaAnuncios, ListaBanners },
  data() {
    return {
      produto: {
        nome: "Clube de Vantagens",
        id: "clubeVantagens",
      },
      breadcrumb: [
        {
          nome: "Clube de Vantagens",
          id: "clubeVantagens",
          produto: "Clube de Vantagens",
        },
      ],
      lista: [],
      listaAnuncio: [],
      listaBanner: [],
      loading: true,
      menu: 1,
      descMenu: "ANÚNCIO",
      linkCadastro: "/produto/clube-vantagens/formulario/anuncio",
      porPagina: 5,
      pagina: 1,
      paginaAnuncio: 1,
      qtdRegistros: 0,
      qtdRegistrosAnuncio: 0,
    };
  },
  methods: {
    alterarMenu(id) {
      if (id === 1) {
        this.descMenu = "ANÚNCIO";
        this.linkCadastro = "/produto/clube-vantagens/formulario/anuncio";
      } else if (id === 2) {
        this.descMenu = "USUÁRIO";
        this.linkCadastro = "/produto/clube-vantagens/formulario/usuarios";
      } else if (id === 3) {
        this.descMenu = "BANNER";
        this.linkCadastro = "/produto/clube-vantagens/formulario/banner";
      }
      this.menu = id;
    },
    selecionaPagina(pagina) {
      this.loading = true;
      this.lista = [];
      this.pagina = pagina;
      this.consultarDados();
    },
    selecionaPaginaAnuncio(pagina) {
      this.loading = true;
      this.lista = [];
      this.paginaAnuncio = pagina;
      this.consultarDados();
    },
    consultarDados() {
      this.listaBanner = [];
      this.lista = [];
      this.listaAnuncio = [];
      this.loading = true;
      this.$http
        .get(
          `/api/Clube/ConsultarFuncionariosClubeVantagens?linhas=${this.porPagina}&pagina=${this.pagina}`
        )
        .then((response) => {
          this.loading = false;
          this.lista = response.data.funcionarios;
          this.qtdRegistros = response.data.totalLinhas;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }

          this.loading = false;
          this.error = error.response.data.mensagem;
        });

      this.$http
        .get(
          `/api/Clube/ConsultarAnunciosClubeVantagens?linhas=${this.porPagina}&pagina=${this.paginaAnuncio}`
        )
        .then((response) => {
          this.loading = false;
          this.listaAnuncio = response.data.anuncios;
          this.qtdRegistrosAnuncio = response.data.totalLinhas;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }

          this.loading = false;
          this.error = error.response.data.mensagem;
        });

      this.$http
        .get(`/api/Clube/ConsultarBannersClubeVantagens`)
        .then((response) => {
          this.loading = false;
          this.listaBanner = response.data.banners;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }

          this.loading = false;
          this.error = error.response.data.mensagem;
        });
    },
    cancelar() {
      this.$router.push({ name: "cancelamentoClube" });
    },
    retorno(payload) {
      if (payload.props.carregarLista) {
        this.consultarDados();
      }
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.loading = false;

    this.$http
      .get("/api/Clube/ConsultarClubeVantagens")
      .then((response) => {
        if (!response.data.status || !response.data.termoAssinado) {
          this.$router.push({ name: "clube-produtos" });
        } else {
          this.consultarDados();
        }
      })
      .catch((error) => {
        if (error.response.status === 400) {
          this.$router.push({ name: "clube-produtos" });
        }
        if (error.response.status === 401) {
          this.$router.push({ name: "login" });
        }

        this.loading = false;
        this.error = error.response.data.mensagem;
      });
  },
};
</script>
<style lang="scss" scoped>
@media screen and(max-width: 900px) {
  #v-pills-tab {
    display: flex;
    flex-direction: row !important;
    justify-content: space-between;
    margin-bottom: 1rem;
    a {
      width: 22%;
      text-align: center;
      justify-content: center;
      align-items: center;
      span {
        display: none;
      }
    }
  }
}
</style>
